import React, { useEffect, useRef, useState } from 'react';
import { FixedFooterLayoutProps } from './interface';
import { FixedFooter } from './InternalFixedFooter.web';

const FOOTER_PADDING = 16;

export const FixedFooterLayout = ({ children, footerContent, title }: FixedFooterLayoutProps) => {
  const { height: footerHeight, ref: footerRef } = useResponsiveFooterSpacer();

  return (
    <>
      <div style={{ paddingBottom: `${footerHeight + FOOTER_PADDING}px` }}>
        {title}
        {children}
      </div>
      <FixedFooter ref={footerRef}>{footerContent}</FixedFooter>
    </>
  );
};

const useResponsiveFooterSpacer = (): {
  height: number;
  ref: React.MutableRefObject<any>;
} => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [height, setHeight] = useState<number>(0);

  useEffect(() => {
    if (!ref.current) {
      return;
    }
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.target.clientHeight !== height) {
          setHeight(entry.target.clientHeight);
        }
      }
    });
    resizeObserver.observe(ref.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return { height, ref };
};
